<template>
    <div class="teacherTeams">
      <div class="container">
        <div class="teacherTeams-header">
          <swiper></swiper>
        </div>
        <div class="teacherTeams-contens">
          <div class="item-teacherTeams-contens">
            <div class="teacherTeams-title"><i></i>师资教研<i></i></div>
            <div class="teacherTeams-content">
              <div class="item-content">
                <div class="content-title">弈小象创始人兼CEO: <span>兰宇</span></div>
<!--                <div class="content-words"> 弈小象创始人兼CEO</div>-->
                <div class="content-words" v-for="(item,index) in llArr" :key="index">
                  <p>{{item.content}}</p>
                </div>
              </div>
              <div class="item-img">
                <img src="../assets/teacher/ll.png"/>
              </div>
            </div>
            <div class="item-detail">
              <div class="item-img">
                <img src="../assets/teacher/rectangle.png" class="rectangle">
                <img :src="teacherdetails.teacherimgbig" class="teacher">
              </div>
              <div class="item-cons">
                <div class="teachers">
                  <div class="item-name"> {{teacherdetails.type}}教师 <span>{{teacherdetails.name}}</span></div>
                  <div class="item-title" >{{teacherdetails.title}}</div>
                  <div class="item-content">{{teacherdetails.content}}</div>
                  <div class="item-content" v-show="teacherdetails.content1">{{teacherdetails.content1}}</div>
                  <div class="item-content" v-show="teacherdetails.content2">{{teacherdetails.content2}}</div>
                  <div class="item-content" v-show="teacherdetails.content3">{{teacherdetails.content3}}</div>
                  <div class="item-content" v-show="teacherdetails.content4">{{teacherdetails.content4}}</div>
                  <div class="item-content" v-show="teacherdetails.content5">{{teacherdetails.content5}}</div>
                </div>
                <div class="teacherTeams-team" ref="team">
                  <div class="teamNav" ref="nav">
                    <div class="item-team" ref="imgs" v-for="(item, index) in teacherTeams" :key="item.id" @click="showbig(item.id,index)"  :class = "isactive == index ? 'item-teams' : '' " >
                      <img :src="item.teacherimgsmall"/>
                    </div>
                  </div>
                </div>
                <img src="../assets/teacher/arrows.png" class="arrows" @click="tabNav">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import Swiper from '../components/swiper.vue'
export default {
  name: 'teacherTeams',
  components: {
    Swiper
  },
  data () {
    return {
      llArr: [
        {content: '4岁开始学棋，年仅14岁便获得全国青少年象棋赛冠军，并被授予“国家棋协大师”称号。2008年参加全国高水平运动员象棋选拔赛取得优异名次，成功保送至南开大学。'},
        {content: '四年的南开时光匆匆过去，兰宇老师的求学之路并未中断，后凭借优秀的学业成绩奖学金留学至澳洲阿德莱德大学，获金融学硕士学位。'},
        {content: '归国后，兰宇老师任职于某知名投资机构。一次偶然的机会，他接触到了幼儿教育项目，秉承着对象棋的热爱与传承发扬的责任感，他毅然决定投身到象棋教育事业中，经过近一年的团队组建与思考学习，2018年，弈小象正式成立。'},
        {content: '“教育是一项伟大的事业，象棋是一座通达的桥梁，它们带给孩子智慧和快乐，拉进了心灵之间的距离；象棋是我们的国粹，孩子是我们未来的希望，文化自信不能只停留在我们这一代，我们更要把好的东西传承下去。'},
        {content: '兰宇老师曾说。他也将始终秉承初心，用全身心的热情支持推广象棋教育，让更多孩子因此受益。'}
      ],
      teacherTeams: [
        {
          id: 1,
          teacherimgsmall: require('../assets/teacher/ymx.png'),
          teacherimgbig: require('../assets/teacher/ymd.png'),
          type: '象棋',
          name: '弈鸣老师',
          title: '弈小象联合创始人',
          content: '首席测评官',
          content1: '资深棋类教练、裁判员',
          content2: '选拔培养多名少儿冠军'
        },
        {
          id: 2,
          teacherimgsmall: require('../assets/teacher/ssx.png'),
          teacherimgbig: require('../assets/teacher/ssd.png'),
          type: '象棋',
          name: '宋宋老师',
          title: '国家等级运动员',
          content: '地方棋协大师',
          content1: '担任北京红庙象棋课老师、北京人大附中象棋课老师',
          content2: '2016年 全国威凯一级运动员象棋比赛前十名',
          content3: '2016年 全国象棋青年赛前十名',
          content4: '2018、19年 全国等级赛前八名'
        },
        {
          id: 3,
          teacherimgsmall: require('../assets/teacher/cx.png'),
          teacherimgbig: require('../assets/teacher/cd.png'),
          type: '象棋',
          name: '崔航',
          title: '清华大学本科及硕士',
          content: '国际棋联大师\n',
          content1: '多次获得两项棋类盛世冠军',
          content2: '曾任清华大学中国象棋队队长',
          content3: '荣获世界象棋联合会授予的国际棋联大师称号'
        },
        {
          id: 4,
          teacherimgsmall: require('../assets/teacher/yyx.png'),
          teacherimgbig: require('../assets/teacher/yyd.png'),
          type: '象棋',
          name: '玉思源',
          title: '中国象棋运动员',
          content: '象棋国家级裁判',
          content1: '毕业于南开大学',
          content2: '2009年 全国象棋一级棋士赛女子组冠军',
          content3: '2010年 晋升为国家象棋大师',
          content4: '2017年 全国象棋团体赛女子冠军'
        },
        {
          id: 5,
          teacherimgsmall: require('../assets/teacher/hmx.png'),
          teacherimgbig: require('../assets/teacher/hmd.png'),
          type: '围棋',
          name: '陈卉敏',
          title: '南开大学文学学士',
          content: '围棋6段\n',
          content1: '国家一级运动员',
          content2: '央视“谁是棋王”特邀棋手',
          content3: '编辑出版《新速成围棋》《聪明围棋阶梯教师》等少儿启蒙系列书籍'
        },
        {
          id: 6,
          teacherimgsmall: require('../assets/teacher/xx.png'),
          teacherimgbig: require('../assets/teacher/xd.png'),
          type: '围棋',
          name: '许婓然',
          title: '围棋职业二段',
          content: '河南省围棋协会理事\n',
          content1: '二十年围棋教学经验',
          content2: '曾多次在"围棋天地"发表围棋研究',
          content3: '曾培养出数十名围棋职业棋手'
        },
        {
          id: 7,
          teacherimgsmall: require('../assets/teacher/kkx.png'),
          teacherimgbig: require('../assets/teacher/kkd.png'),
          type: '国际象棋',
          name: '康凯',
          title: '南开大学高水平运动员',
          content: '国际棋联国际级教练\n',
          content1: '国家一级运动员',
          content2: '国际象棋棋协大师'
        },
        {
          id: 8,
          teacherimgsmall: require('../assets/teacher/dwx.png'),
          teacherimgbig: require('../assets/teacher/dwd.png'),
          type: '国际象棋',
          name: '李大卫老师',
          title: '国际象棋棋协大师',
          content: '国际象棋课程体系搭建师\n',
          content1: '曾任人大附中 国家少年队队员',
          content2: '北京市青少儿国际象棋赛冠军',
          content4: '10年+教学经验',
          content5: '曾担任人大附中、史家小学等名校国际象棋课程教师',
          content6: '学员等级赛总升级率超过90%'
        }
      ],
      teacherdetails: {
        id: 1,
        teacherimgsmall: require('../assets/teacher/ymx.png'),
        teacherimgbig: require('../assets/teacher/ymd.png'),
        type: '象棋',
        name: '弈鸣老师',
        title: '弈小象联合创始人',
        content: '首席测评官',
        content1: '资深棋类教练、裁判员',
        content2: '选拔培养多名少儿冠军'
      },
      isactive: 0,
      n: 0
    }
  },
  methods: {
    showbig (leaveimg, index) {
      console.log('jin', leaveimg, index)
      leaveimg = leaveimg - 1
      this.teacherdetails = this.teacherTeams[leaveimg]
      this.isactive = index
      console.log(this.teacherdetails)
    },
    // 点击下一张
    tabNav () {
      if (this.isactive === this.teacherTeams.length - 1) {
        this.isactive = 0
        this.n = -196
        this.teacherdetails = this.teacherTeams[this.isactive]
        this.$nextTick(() => {
          this.scroll = new BScroll(this.$refs.team, {
            startX: -this.n, // 配置的详细信息请参考better-scroll的官方文档
            scrollX: true
          })
        })
      } else {
        this.isactive++
        this.teacherdetails = this.teacherTeams[this.isactive]
        // 上一张隐藏 下一张显示
        this.$nextTick(() => {
          this.scroll = new BScroll(this.$refs.team, {
            startX: -this.n, // 配置的详细信息请参考better-scroll的官方文档
            scrollX: true
          })
        })
        for (var i = 0; i <= 5; i++) {
          this.n = 179 * this.isactive
          if (this.isactive > 5) {
            this.n = 179 * i
          }
        }
      }
    }
  },
  mounted () {
    // 滑动图片
    let width = (this.teacherTeams.length + 1) * 161// 动态计算出滚动区域的大小，产生滚动的原因是滚动区域宽度大于父盒子宽度
    this.$refs.nav.style.width = width + 'px' // 修改滚动区域的宽度
    this.$nextTick(() => {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.team, {
          startX: 0, // 配置的详细信息请参考better-scroll的官方文档
          scrollX: true
        })
      } else {
        this.scroll.refresh() // 如果dom结构发生改变调用该方法
      }
    })
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .teacherTeams{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container{
      width: 100%;
      .teacherTeams-header{
        width: 100%;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .teacherTeams-contens {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-teacherTeams-contens {
          width: 100%;
          margin-bottom: 100px;
          .teacherTeams-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            i{
              display: inline-block;
              width: 23px;
              height: 23px;
              margin-right: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_left.png');
            }
            i:last-of-type{
              margin-left: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_right.png');
            }
          }
          .teacherTeams-content {
            width: 1180px;
            margin: auto;
            @include flex();
            background:#4ACEFF;
            margin-top: 35px;
            margin-bottom: 50px;
            border-radius: 50px;
            .item-content {
              width:591px;
              padding-right: 40px;
              padding-left: 63px;
              box-sizing: border-box;
              text-align: left;
              color: #fff;
              .content-title{
                font-size:30px;
                font-family:Microsoft YaHei;
                font-weight:400;
                text-align: left;
                span{
                  margin-left: 50px;
                  font-size:40px;
                  font-family:Microsoft YaHei;
                  font-weight:bold;
                  display: inline-block;
                }
              }
              .content-words{
                margin-top: 40px;
                font-size:16px;
                font-family:Microsoft YaHei;
                font-weight:400;
                line-height:21px;
                letter-spacing: 2px;
                text-indent: 2em;
                margin-top: 20px;
                p{
                  text-indent: 35px;
                }
                @media only screen and (min-width: 540px) and (max-width: 1180px){
                  margin-top: 20px;
                }
              }
            }
            .item-img{
              width: 589px;
              height: 632px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          .item-detail{
            width: 100%;
            @include flexed();
            margin-bottom: 40px;
            .item-img {
              width: 350px;
              height: 438px;
              margin-right: 35px;
              position: relative;
              .rectangle{
                width: 350px;
                height: 115px;
                position: absolute;
                bottom: -26px;
                left: 0;
              }
              .teacher{
                display: block;
                width: 328px;
                height: 412px;
                z-index: 999999;
                position: absolute;
                top: 0;
                left: 11px;
              }
            }
            .item-cons {
              width: 795px;
              text-align: left;
              font-weight:400;
              color:rgba(51,51,51,1);
              font-size: 14px;
              padding: 0 30px;
              box-sizing: border-box;
              display: flex;
              flex-wrap: wrap;
              position: relative;
              .teachers{
                flex: 1;
                .item-name{
                  font-size:18px;
                  font-family:Microsoft YaHei;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                  margin-top: 30px;
                  span{
                    display: inline-block;
                    font-size:24px;
                    font-weight:bold;
                    margin-left: 50px;
                    margin-right: 10px;
                  }
                }
                .item-title{
                  width: 450px;
                  margin-top: 15px;
                }
                .item-content{
                  width: 450px;
                  margin-top: 5px;
                }
              }
              .teacherTeams-team{
                width: 90%;
                position: absolute;
                bottom: -26px;
                overflow: hidden;
                .teamNav{
                  // white-space: nowrap;
                  @include flexnormal();
                  .item-team {
                  width: 161px;
                  height: 191px;
                  opacity: 0.6;
                  margin-right: 18px;
                  cursor: pointer;
                  }
                  .item-teams{
                    opacity: 1;
                  }
                }
              }
              .arrows{
                width: 28px;
                height: 52px;
                position: absolute;
                right: 2%;
                bottom: 10%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/teacherTeams.vue